import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    # INLINE-NOTIFICATION
\*------------------------------------ */
/**
 * Inline-Notification
 * 1) Message of information, success, error, or warning to the user
 */
.cat-c-inline-notification {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  position: relative;
  color: var(--cat-theme-color-content-strong);
  background-color: var(--cat-theme-color-background-utility-information);
  border-style: solid;
  border-width: var(--cat-border-width-sm);
  border-inline-start-width: var(--cat-border-width-lg);
  border-color: var(--cat-theme-color-border-utility-information);
  padding: var(--cat-space-medium);
  min-height: 4rem;
}
@media all and (min-width: 48rem) {
  .cat-c-inline-notification {
    flex-flow: row nowrap;
    padding: var(--cat-space-medium);
    justify-content: space-between;
  }
}

/**
 * Inline-Notification success
 */
.cat-c-inline-notification--success {
  background-color: var(--cat-theme-color-background-utility-success);
  border-color: var(--cat-theme-color-border-utility-success);
}

/**
 * Inline-Notification warning
 */
.cat-c-inline-notification--warning {
  background-color: var(--cat-theme-color-background-utility-warning);
  border-color: var(--cat-theme-color-border-utility-warning);
}

/**
 * Inline-Notification error
 */
.cat-c-inline-notification--error {
  background-color: var(--cat-theme-color-background-utility-error);
  border-color: var(--cat-theme-color-border-utility-error);
}

/**
 * Inline-Notification close button
 */
.cat-c-inline-notification__close-button {
  position: absolute;
  inset-block-start: var(--cat-inline-notification-close-icon-top, var(--cat-space-medium));
  inset-inline-end: var(--cat-inline-notification-close-icon-top, var(--cat-space-medium));
  --cat-button-padding: calc(var(--size-base-unit) * 0.625);
}

/**
 * Inline-Notification with close button
 */
.cat-is-dismissible {
  padding-inline-end: var(--cat-space-3x-large);
}

/**
 * Inline-Notification icon
 */
.cat-c-inline-notification__icon {
  display: flex;
  align-items: center;
  position: relative;
  margin-inline-end: var(--cat-space-x-small);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-fill: var(--cat-theme-color-content-utility-information);
  /**
   * Inline-Notification icon within success inline-notification
   */
  /**
   * Inline-Notification icon within warning inline-notification
   */
  /**
   * Inline-Notification icon error
   */
}
.cat-c-inline-notification--success .cat-c-inline-notification__icon {
  --cat-icon-fill: var(--cat-theme-color-content-utility-success);
}
.cat-c-inline-notification--warning .cat-c-inline-notification__icon {
  --cat-icon-fill: var(--cat-theme-color-content-utility-warning);
}
.cat-c-inline-notification--error .cat-c-inline-notification__icon {
  --cat-icon-fill: var(--cat-theme-color-content-utility-error);
}

/**
 * Inline-Notification body
 * 1) Allows the body to take up the remaining space that the icon doesn't occupy
 */
.cat-c-inline-notification__body {
  flex-basis: 100%;
  word-break: break-word;
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
}

/**
 * Inline-Notification title
 * 1) Styles applied to the div tag which resembles styles of heading tag
 */
.cat-c-inline-notification__title {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  color: var(--cat-theme-color-content-default);
  margin: var(--cat-heading-margin, 0);
}

/**
 * Inline-Notification content
 * 1) Wrapper that contains the icon and body
 */
.cat-c-inline-notification__content {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}
@media all and (min-width: 48rem) {
  .cat-c-inline-notification__content {
    width: auto;
  }
}

/**
 * Inline-Notification after
 * 1) Wrapper that contains buttons
 */
.cat-c-inline-notification__after {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-block-start: var(--cat-space-x-small);
  margin-inline-start: 0;
  width: var(--cat-inline-notification-button-conatiner__width, 100%);
  padding-inline-start: var(--cat-space-x-large);
  /**
   * Add margin left to all slot items if not the first child
   */
}
@media all and (min-width: 48rem) {
  .cat-c-inline-notification__after {
    margin-inline-start: var(--cat-space-x-small);
    margin-block-start: 0;
    width: var(--cat-inline-notification-button-conatiner__width, auto);
    justify-content: flex-end;
    padding-inline-start: 0;
    white-space: var(--cat-inline-notification-button-conatiner__white-space, nowrap);
  }
}
.cat-c-inline-notification__after > * + * {
  margin-inline-start: var(--cat-space-3x-small);
}

.cat-c-inline-notification:not(.cat-c-inline-notification--has-slot-before) .cat-c-inline-notification__icon, .cat-c-inline-notification:not(.cat-c-inline-notification--has-slot-after) .cat-c-inline-notification__after {
  display: none;
}
`;
       